export default __webpack_public_path__ + "static/media/banner.20aad09b.png";